import { useEffect, useState } from "react";
import { fetchClubMemberDiscount } from "@/lib/api";

let cached = null;

// Standing Club member discount rule (server is the source of truth for the final amount).
export const useMemberDiscountRule = () => {
    const [rule, setRule] = useState(cached);
    useEffect(() => {
        if (cached) return;
        fetchClubMemberDiscount().then((r) => { cached = r; setRule(r); }).catch(() => {});
    }, []);
    return rule;
};

export const computeMemberDiscount = (rule, { member, hasCode, orderType = "collection", subtotal }) => {
    if (!rule?.active || !member || hasCode || !(rule.value > 0) || subtotal < (rule.min_order || 0)) return 0;
    if (rule.collection_only && orderType !== "collection") return 0;
    return rule.type === "percent"
        ? Math.round(subtotal * rule.value) / 100
        : Math.min(rule.value, subtotal);
};

export const memberDiscountLabel = (rule) =>
    rule?.type === "percent" ? `Club member ${rule.value}%` : `Club member £${Number(rule?.value || 0).toFixed(2)} off`;
